/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-01 10:20:07
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-12 10:34:03
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/LinkProduct/index.tsx
 */
import React from 'react';

import {
  Button,
  SectionCollapse,
  SizeFittingTable,
} from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import { ProductItem } from '@/src/types/common/product';
import TagGroup from 'src/components/TagGroup/TagGroup';
import styles from './style.module.less';
//import { EnumTablePosition } from 'src/types/common/common';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';

type Props = {
  products: Array<ProductItem>;
  disabled?: boolean;
  onDelete: (index: number) => void;
  onClickLnkBtn: () => void;
  getI18n: (k: string) => string;
};

function LinkProduct({
  products,
  disabled,
  onDelete,
  onClickLnkBtn,
  getI18n,
}: Props) {
  const columns = [
    {
      fixedWidth: 56,
      default: true,
      title: '',
      key: 'index',
      childGenerate: (_, __, index: number) => index + 1,
    },
    {
      width: 56,
      default: true,
      title: '',
      dataIndex: 'thumbnailUrl',
      key: 'thumbnailUrl',
      childGenerate: (text: string) => {
        return (
          <div
            className={styles.img}
            style={{ backgroundImage: `url('${text}')` }}
          />
        );
      },
    },
    {
      minWidth: 160,
      default: true,
      title: getI18n('general.sKU'),
      key: 'SKU',
      dataIndex: 'sku',
    },
    {
      minWidth: 250,
      default: true,
      title: getI18n('general.productName'),
      dataIndex: 'name',
      key: 'name',
      // ellipsis: true,
    },
    {
      width: 120,
      default: true,
      title: getI18n('general.productType'),
      key: 'productType',
      dataIndex: 'productType',
    },
    {
      minWidth: 160,
      default: true,
      title: getI18n('general.remarks'),
      key: 'remarks',
      dataIndex: 'remarks',
      childGenerate: (text: string) => {
        return (
          <NoWrapContainer>
            <GlobalTooltip title={text || '-'}>{text || '-'}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      title: getI18n('general.tags'),
      dataIndex: 'tags',
      default: true,
      optional: true,
      align: 'center',
      //className: css.columnClass,
      key: 'tags',
      minWidth: 272,
      tags: true,

      tagsGenerator: (
        characterLength,
        width,
        marginPaddingWidth,
        containPaddingWidth,
        tags,
        record,
      ) => {
        return (
          <TagGroup
            characterLength={characterLength}
            containerWidth={width}
            marginPaddingWidth={marginPaddingWidth}
            containPaddingWidth={containPaddingWidth}
            tags={tags}
          />
        );
      },
    },
    !disabled && {
      width: 48,
      title: '',
      key: 'action',
      default: true,
      childGenerate: (_, __, index: number) => {
        return (
          <Icon
            type='icondelete'
            className={styles.warnning}
            onClick={() => {
              onDelete(index);
            }}
          />
        );
      },
    },
  ];

  const renderContent = () => {
    return (
      <div className={styles.content}>
        <div className={styles.desc}>
          {getI18n('salesChannelProductDetail.index.linkeProductDesc')}
        </div>
        {!disabled && (
          <div className={styles.add}>
            <Button
              type='primary'
              icon={<Icon type='iconlink' />}
              onClick={onClickLnkBtn}>
              {getI18n('salesChannelProductDetail.index.clicktoLinkProduct')}
            </Button>
          </div>
        )}
        {products.length !== 0 && (
          <SizeFittingTable
            id={'linkProductTable'}
            rowKey={'uuid'}
            pagination={false}
            //  showHeader={false}
            columns={columns}
            dataSource={products}
            scroll={{ x: true }}
          />
        )}
      </div>
    );
  };

  return (
    <SectionCollapse
      open={true}
      id={'linkProduct'}
      titleStyle={{ height: '64px' }}
      title={
        <div className={'collapseTitle'}>
          {getI18n('salesChannelProductDetail.index.linkProduct')}*
        </div>
      }
      content={renderContent()}
      openMargin={16}
    />
  );
}

export default LinkProduct;
